import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "cx-surface-filters" }
const _hoisted_2 = { class: "cx-surface-filters__form" }
const _hoisted_3 = { class: "cx-surface-filters__filter-row" }
const _hoisted_4 = {
  key: 0,
  class: "cx-surface-filters__filter-row"
}
const _hoisted_5 = { class: "cx-surface-filters__filter-row" }
const _hoisted_6 = { class: "cx-surface-filters__filter-row" }
const _hoisted_7 = { class: "cx-surface-filters__buttons" }
const _hoisted_8 = { class: "cx-surface-filters__results" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = { class: "n-cx-select-display-settings" }

import { ref, Ref, computed, onMounted, ComputedRef } from 'vue';
import { useStore } from 'vuex';
import useWaffleFlag from '@/composables/useWaffleFlag';
import useAnimation from '@/composables/useAnimation';
import { uniqBy } from 'lodash';
import CxButton from '@/components/CxButton.vue';
import CxList from '@/components/list/CxList.vue';
import CxListItem from '@/components/list/CxListItem.vue';
import CxIcon from '@/components/CxIcon.vue';
import CxLabel from '@/components/CxLabel.vue';
import NCxSelect from '@/components/NCxSelect.vue';
import CxUnitTypeFilter from '@/app/filterPanel/common/CxUnitTypeFilter.vue';
import CxPointCodesFilter from '@/app/filterPanel/asbuilts/components//CxPointCodesFilter.vue';
import CxFilterTitle from '../common/CxFilterTitle.vue';
import CxTimeRangeFilter from '@/app/filterPanel/common/CxTimeRangeFilter.vue';
import CxMenuButton from '@/components/menuComponents/CxMenuButton.vue';
import CxFilterActionPanel from '../common/CxFilterActionPanel.vue';
import { surfacelogApi } from '@/http/surfacelog.api';
import { withFullPath } from '@/domain/entityMixins';
import translationService from '@/services/translation.service';
import { endOfToday, startOfToday, formatISO, max, startOfDay, endOfDay, format } from 'date-fns';
import { createSurfacelog } from '@/domain/surfacelog/SurfacelogFactory';
import { Surfacelog, SurfacelogDeltaHeightLegend } from '@/domain/surfacelog/Surfacelog';
import { SurfacelogSignalTypes } from '@/domain/surfacelog/SurfacelogSignalTypes.enum';
import { SurfaceErrors } from '@/domain/surfacelog/SurfaceErrors.enum';
import { convert } from '@/utils/measurementUnitHelper';
import { SurfacelogExportExtensionTypes } from '@/domain/surfacelog/SurfacelogExportExtensionTypes.enum';
import { SurfacelogExportExtensionLabels } from '@/domain/surfacelog/SurfacelogExportExtensionLabels.enum';
import { MeasurementSystem } from '@/domain/MeasurementSystem';
import { gettext } from '@/translations/gettext.setup';
import { UnitTypes } from '@/domain/units/UnitTypes.enum';
import CxRefModelsFilter from '@/app/filterPanel/common/CxRefModelsFilter.vue';
import { PointCodesType } from '@/domain/surfacelog/PointCodesType';

// Composables and Plugins

export default /*#__PURE__*/_defineComponent({
  __name: 'CxSurfaceFilters',
  setup(__props, { expose: __expose }) {

const store = useStore();
const { $gettext } = gettext;
const { applyAnimations, isAnimationReady } = useAnimation('CxSurfaceFilters');

// Data
const activeDaysLoading: Ref<boolean> = ref(false);
const activeDays: Ref<Date[]> = ref([]);
const refmodels: Ref<{id: string, title: string, subtitle: string}[]> = ref([]);
const pointCodes: Ref<PointCodesType> = ref([]);
const refmodelsLoading: Ref<boolean> = ref(false);
const pointCodesLoading: Ref<boolean> = ref(false);
const searching: Ref<boolean> = ref(false);
const results: Ref<{id: string, title: string}[]> = ref([]);
const unitsLoading: Ref<boolean> = ref(false);
const surfacelog: Ref<Surfacelog | null> = ref(null);
const displayLoading: Ref<boolean> = ref(false);
const exporting: Ref<boolean> = ref(false);

// Computed
const selectedRefmodelPaths: ComputedRef<string[]> = computed(() => store.getters['filterSurfaces/selectedRefmodelPaths']);
const selectedPointCodes: ComputedRef<PointCodesType> = computed(() => store.getters['filterSurfaces/selectedPointCodes']);
const selectedUnitTypes: ComputedRef<string[]> = computed(() => store.getters['filterSurfaces/selectedUnitTypes']);
const selectedUnitNames: ComputedRef<string[]> = computed(() => store.getters['filterSurfaces/selectedUnitNames']);
const startDate: ComputedRef<Date> = computed(() => store.getters['filterSurfaces/startDate']);
const endDate: ComputedRef<Date> = computed(() => store.getters['filterSurfaces/endDate']);
const units: ComputedRef<{ name: string, type: string }[]> = computed(() => store.getters['filterSurfaces/units']);
const isResult: ComputedRef<boolean> = computed(() => store.getters['filterSurfaces/isResult']);
const selectedCellSize: ComputedRef<number | null> = computed(() => store.getters['filterSurfaces/selectedCellSize']);

const projectUuid: ComputedRef<string> = computed(() => store.getters.projectUuid);
const projectStartDay: ComputedRef<Date> = computed(() => store.getters['app/projectStartDay']);
const measurementSystem: ComputedRef<MeasurementSystem> = computed(() => store.getters['app/measurementSystem']);
const cellSizesTooledge: ComputedRef<number[]> = computed(() => store.getters['map/cellSizesTooledge']);
const exportExtensions: ComputedRef<{name: SurfacelogExportExtensionLabels, value: SurfacelogExportExtensionTypes}[]> = computed(() => store.getters['map/exportExtensions']);


const translations = computed(() => ({
  clearFilters: $gettext('Clear Filters'),
  search: $gettext('Search'),
  result: $gettext('Results'),
  noResult: $gettext('No results'),
  referenceModels: $gettext('Reference Model(s)'),
  referenceModelsPlaceholder: $gettext('Select Reference Model'),
  pointCodes: $gettext('Surface log'),
  pointCodesPlaceholder: $gettext('Select Surfacelog'),
  errorMessage: $gettext('Fetching data for Surface Filtering Panel failed. Try reopening the panel or contact support.'),
  filterErrorMessage: $gettext('Fetching surface failed. Try again or contact support.'),
  unitTypeFilter: $gettext('Units'),
  unitNameFilter: $gettext('Unit names'),
  dateAndTime: $gettext('Date And Time'),
  display: $gettext('Display'),
  displayError: $gettext('Display surfacelog failed. Try again or contact support.'),
  export: $gettext('Save surface as...'),
  cellSize: $gettext('cell size'),
  exportError: $gettext('Export failed. Try again or contact support.'),
  rasterSizeError: $gettext('Output surface size is too big. Please narrow your search criteria. Try choosing higher cellsize to decrease resolution.'),
  tooMuchDataError: $gettext('To much data to process. Please narrow your search criteria.'),
  displaySettings: $gettext('Display Settings'),
  cellSizes: $gettext('Select cell size'),
}));

const cellSizes = computed(() => {
  return cellSizesTooledge.value;
});

const cellSizesToDisplay = computed(() => {
  const lengthUnit = measurementSystem.value.baseLengthUnit.name;
  const cellSizesByUnits = cellSizes.value[lengthUnit];
  return cellSizesByUnits.map(cellSize => {
    return { id: cellSize, title: `${translations.value.cellSize}: ${cellSize} ${lengthUnit}` };
  });

});

const defaultCellSize = computed(() => {
  return cellSizesToDisplay.value.slice(-1)[0].id;
});



const listHeader = computed(() => {
  return results.value.length ? translations.value.result : translations.value.noResult;
});
const selectedReferenceModelPaths = computed(() => {
  return selectedRefmodelPaths.value ? selectedRefmodelPaths.value : [];
});
const searchButtonDisabled = computed(() => {
  return (!selectedRefmodelPaths.value || refmodelsLoading.value || activeDaysLoading.value);
});
const clearButtonDisabled = computed(() => {
  return refmodelsLoading.value || activeDaysLoading.value || searching.value;
});
const allLoadedEntities: ComputedRef<any> = computed(() => store.getters['map/allLoadedEntities']);

const displayButtonDisabled = computed(() => {
  let isSurfaceDisplayed = false;
  if (surfacelog.value) {
    isSurfaceDisplayed = !!allLoadedEntities.value.find(e => e.uuid === surfacelog.value!.uuid);
  }
  return results.value.length === 0 || isSurfaceDisplayed || !selectedCellSize.value;
});

const exportButtonDisabled = computed(() => {
  return results.value.length === 0 || !selectedCellSize.value;
});

const availableUnits = computed(() => {
  return units.value
    .filter(u => {
      if (selectedUnitTypes.value.length) return selectedUnitTypes.value.includes(u.type);
      return u;
    })
    .map(u => ({
      id: u.name,
      title: u.name,
      subtitle: translationService.get(u.type)
    }));
});
const availableUnitTypes = computed(() => {
  const uniqueTypeUnits = uniqBy(units.value, 'type');
  return uniqueTypeUnits.map((u) => {
    return {
      id: u.type,
      name: translationService.get(u.type)
    };
  });
});
const selectedUnitsToSend = computed((): [] => {
  let result;
  if (selectedUnitNames.value.length) {
    result = units.value.filter(u => { return selectedUnitNames.value.includes(u.name); });
  } else {
    result = units.value.filter((u) => {
      return selectedUnitTypes.value.includes(u.type);
    });
  }
  return result;
});
const commonFilterDisabled = computed(() => refmodelsLoading.value);

// Methods
const setSelectedRefmodelPath = (path: string[]) => { store.commit('filterSurfaces/setSelectedRefmodelPath', path); };
const setSelectedPointCodes = (point_codes: PointCodesType) => { store.commit('filterSurfaces/setSelectedPointCodes', point_codes); };
const setSelectedUnitTypes = (types: string[]) => { store.commit('filterSurfaces/setSelectedUnitTypes', types); };
const setSelectedUnitNames = (names: string[]) => { store.commit('filterSurfaces/setSelectedUnitNames', names); };
const setStartDate = (date: Date | null) => { store.commit('filterSurfaces/setStartDate', date); };
const setEndDate = (date: Date | null) => { store.commit('filterSurfaces/setEndDate', date); };
const setUnits = (unitsToSet: {name: string, type: UnitTypes}[]) => { store.commit('filterSurfaces/setUnits', unitsToSet); };
const setIsResult = (isResultValue: boolean) => { store.commit('filterSurfaces/setIsResult', isResultValue); };
const setSelectedCellSize = (cellSize: number | null) => { store.commit('filterSurfaces/setSelectedCellSize', cellSize); };

const addEntities = async (value: { entities: (Surfacelog | null)[] }) => { await store.dispatch('map/addEntities', value); };
const error = async (err: {exception?: unknown, message: string}) => { await store.dispatch('notifications/error', err); };


const fetchActiveDays = async () => {
  activeDaysLoading.value = true;
  try {
    activeDays.value = await surfacelogApi.getActiveDays(projectUuid.value, selectedRefmodelPaths.value, selectedPointCodes.value);
    if (activeDays.value.length > 0) {
      const dateFrom = startOfDay(max(activeDays.value));
      const dateTo = endOfDay(dateFrom);
      setStartDate(dateFrom);
      setEndDate(dateTo);
    } else {
      setStartDate(startOfToday());
      setEndDate(endOfToday());
    }

  } catch (err) {
    error({ exception: err, message: translations.value.errorMessage });
  } finally {
    activeDaysLoading.value = false;
  }
};

const fetchUnits = async () => {
  unitsLoading.value = true;
  try {
    const fetchedUnits = await surfacelogApi.getSurfacelogUnits(projectUuid.value, selectedRefmodelPaths.value, selectedPointCodes.value);
    setUnits(fetchedUnits);
  } catch (err) {
    error({ exception: err, message: translations.value.errorMessage });
  } finally {
    unitsLoading.value = false;
  }
};



const handleSelectedPointCodes = (items: string[]) => {
  setSelectedPointCodes(pointCodes.value.filter(i => items.includes(i.point_code)));
  fetchActiveDays();
  fetchUnits();
};

const clearFilters = async () => {
  setSelectedRefmodelPath([]);
  setSelectedUnitNames([]);
  setSelectedUnitTypes([]);
  setSelectedPointCodes([]);
  setSelectedCellSize(null);
  await fetchActiveDays();
  await fetchUnits();
  results.value = [];
  setIsResult(false);
};


const changeSelectedUnitTypes = (unitTypes: string[]) => {
  setSelectedUnitTypes(unitTypes);
};

const handleSelectedRefModels = async (items: string[]) => {
  setSelectedRefmodelPath(items);
  fetchActiveDays();
  fetchUnits();
};


const getDeltaHeightLegend: ComputedRef<(layerUuid: string | null) => SurfacelogDeltaHeightLegend> = computed(() => (layerUuid: string | null) => store.getters['detailsSurfacelog/getDeltaHeightLegend'](layerUuid));

const setDeltaHeightLegend = (deltaHeight) => { store.commit('detailsSurfacelog/setDeltaHeightLegend', deltaHeight); };

const fetchRefmodels = async () => {
  refmodelsLoading.value = true;
  try {
    const rawRefmodels = await surfacelogApi.getRefmodels(projectUuid.value);
    refmodels.value = rawRefmodels.map(withFullPath).map(refmodel => ({
      id: refmodel.refmodelPath,
      title: refmodel.name,
      subtitle: refmodel.fullPath
    })).sort((a, b) => a.title.localeCompare(b.title));
  } catch (err) {
    error({ message: translations.value.errorMessage });
  } finally {
    refmodelsLoading.value = false;
  }
};

const fetchPointCodes = async () => {
  pointCodesLoading.value = true;
  try {
    const rawPointCodes = await surfacelogApi.getPointCodes(projectUuid.value);
    pointCodes.value = rawPointCodes.sort((a, b) => a.point_code.localeCompare(b.point_code));
  } catch (err) {
    error({ message: translations.value.errorMessage });
  } finally {
    pointCodesLoading.value = false;
  }
};

const restoreUnitFilter = () => {
  setSelectedUnitTypes(selectedUnitTypes.value.filter(t => units.value.find(u => u.type === t)));
  setSelectedUnitNames(selectedUnitNames.value.filter(n => units.value.find(u => u.name === n)));
};

const search = async () => {
  searching.value = true;
  let resultAvailable = false;
  try {
    resultAvailable = await surfacelogApi.filterSurface(projectUuid.value, selectedRefmodelPaths.value, startDate.value, endDate.value, selectedUnitsToSend.value, selectedPointCodes.value);
    if (resultAvailable) {
      const refmodelName = selectedRefmodelPaths.value ? refmodels.value.find(r => r.id === selectedRefmodelPaths.value)?.title : null;
      const surfacelogDhLegend = getDeltaHeightLegend.value(null);
      const lengthUnit = measurementSystem.value.baseLengthUnit;
      surfacelog.value = createSurfacelog({
        name: null,
        uuid: null,
        refmodelPaths: selectedRefmodelPaths.value,
        refmodelName: refmodelName || null,
        pointCodes: selectedPointCodes.value,
        startDate: startDate.value,
        endDate: endDate.value,
        units: selectedUnitsToSend.value,
        unitTypes: selectedUnitNames.value.length ? [] : selectedUnitTypes.value as [],
        signalsKPI: {},
        availableSignals: [] as SurfacelogSignalTypes[],
        deltaHeightLegend: surfacelogDhLegend,
        cellSize: defaultCellSize.value,
        lengthUnit
      });
      setDeltaHeightLegend({ layerUuid: surfacelog.value.uuid, legend: surfacelogDhLegend });
      setSelectedCellSize(defaultCellSize.value);
      results.value = [{
        id: surfacelog.value.uuid,
        title: surfacelog.value.name
      }];
    } else {
      results.value = [];
      surfacelog.value = null;
    }

  } catch (err) {
    error({ exception: err, message: translations.value.filterErrorMessage });
  } finally {
    searching.value = false;
  }
};


const display = async () => {
  displayLoading.value = true;
  try {
    surfacelog.value.cellSize = selectedCellSize.value;
    await addEntities({ entities: [surfacelog.value] });
  } catch (err: any) {
    const errorCode = err.response?.data?.detail;
    if (errorCode === SurfaceErrors.RasterTooBig) {
      error({ exception: err, message: translations.value.rasterSizeError });
    } else if (errorCode === SurfaceErrors.TooMuchData) {
      error({ exception: err, message: translations.value.tooMuchDataError });
    } else if (errorCode === SurfaceErrors.VisualizationFailed) {
      error({ exception: err, message: translations.value.displayError });
    } else {
      error({ exception: err, message: translations.value.displayError });
    }
  } finally {
    displayLoading.value = false;
  }
};

const exportSurfaceLog = async (extension: string) => {
  exporting.value = true;
  const convertedCellSize = convert(selectedCellSize.value).withPrecision(2).from(measurementSystem.value.baseLengthUnit.name).to('m');
  try {
    await surfacelogApi.exportSurfacelog({
      projectUuid: projectUuid.value,
      output: extension,
      startDate: formatISO(new Date(startDate.value)),
      endDate: formatISO(new Date(endDate.value)),
      refmodelPaths: selectedRefmodelPaths.value,
      cellSize: convertedCellSize,
      units: selectedUnitsToSend.value,
      measurementUnit: measurementSystem.value.baseLengthUnit,
      fileName: `ConX_Surfacelog_${format(new Date(Date.now()), 'yyyy-MM-dd_hh:mm:ss')}.xml`,
      pointCodes: selectedPointCodes.value,
    });
  } catch (err) {
    error({ message: translations.value.exportError });
  } finally {
    exporting.value = false;
  }
};



const mountToolEdge = async () => {
  setIsResult(false);
  results.value = [];
  await fetchRefmodels();
  await fetchPointCodes();
  await fetchUnits();
  await fetchActiveDays();
  restoreUnitFilter();
  if (selectedRefmodelPaths.value) {
    await fetchActiveDays();
  }
  if (isResult.value) {
    await search();
  }
};

onMounted(async () => {
  mountToolEdge();
});

__expose({
  fetchActiveDays
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter2')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createVNode(CxFilterTitle, {
              title: translations.value.referenceModels,
              rank: 4
            }, null, 8, ["title"]),
            _createVNode(CxRefModelsFilter, {
              availableRefModels: refmodels.value,
              selectedRefModels: selectedReferenceModelPaths.value,
              changeSelectedRefModels: handleSelectedRefModels,
              loading: refmodelsLoading.value,
              disabled: false,
              label: translations.value.referenceModels
            }, null, 8, ["availableRefModels", "selectedRefModels", "loading", "label"])
          ], 512), [
            [_vShow, _unref(isAnimationReady)]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter2')
      }, {
        default: _withCtx(() => [
          (selectedPointCodes.value)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(CxFilterTitle, {
                  title: translations.value.pointCodes,
                  rank: 4
                }, null, 8, ["title"]),
                _createVNode(CxPointCodesFilter, {
                  availablePointCodes: pointCodes.value,
                  selectedPointCodes: selectedPointCodes.value.map(p => p.point_code),
                  changeSelectedPointCodes: handleSelectedPointCodes,
                  disabled: commonFilterDisabled.value,
                  loading: pointCodesLoading.value
                }, null, 8, ["availablePointCodes", "selectedPointCodes", "disabled", "loading"])
              ], 512)), [
                [_vShow, _unref(isAnimationReady)]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter3')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createVNode(CxFilterTitle, {
              title: translations.value.dateAndTime,
              rank: 4
            }, null, 8, ["title"]),
            _createVNode(CxTimeRangeFilter, {
              startDate: startDate.value,
              changeStartDate: setStartDate,
              endDate: endDate.value,
              changeEndDate: setEndDate,
              projectStartDay: projectStartDay.value,
              events: activeDays.value,
              disabled: commonFilterDisabled.value,
              loading: activeDaysLoading.value
            }, null, 8, ["startDate", "endDate", "projectStartDay", "events", "disabled", "loading"])
          ], 512), [
            [_vShow, _unref(isAnimationReady)]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter4')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(CxFilterTitle, {
              title: translations.value.unitTypeFilter,
              rank: 4
            }, null, 8, ["title"]),
            _createVNode(CxUnitTypeFilter, {
              availableUnitTypes: availableUnitTypes.value,
              selectedUnitTypes: selectedUnitTypes.value,
              changeSelectedUnitTypes: changeSelectedUnitTypes,
              disabled: commonFilterDisabled.value,
              loading: unitsLoading.value
            }, null, 8, ["availableUnitTypes", "selectedUnitTypes", "disabled", "loading"]),
            _withDirectives(_createVNode(NCxSelect, {
              items: availableUnits.value,
              selectedItemIds: selectedUnitNames.value,
              "onUpdate:selectedItemIds": setSelectedUnitNames,
              activatorPlaceholder: translations.value.unitNameFilter,
              multiselect: true,
              disabled: commonFilterDisabled.value,
              loading: unitsLoading.value
            }, null, 8, ["items", "selectedItemIds", "activatorPlaceholder", "disabled", "loading"]), [
              [_vShow, _unref(isAnimationReady)]
            ])
          ], 512), [
            [_vShow, _unref(isAnimationReady)]
          ])
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter5')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createVNode(CxButton, {
              disabled: clearButtonDisabled.value,
              onClick: clearFilters,
              variantSecondary: "",
              tooltip: translations.value.clearFilters
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(translations.value.clearFilters), 1)
              ]),
              _: 1
            }, 8, ["disabled", "tooltip"]),
            _createVNode(CxButton, {
              disabled: searchButtonDisabled.value,
              onClick: search,
              variantPrimary: "",
              tooltip: translations.value.search,
              loading: searching.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(translations.value.search), 1)
              ]),
              _: 1
            }, 8, ["disabled", "tooltip", "loading"])
          ], 512), [
            [_vShow, _unref(isAnimationReady)]
          ])
        ]),
        _: 1
      }, 8, ["name"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_Transition, {
        name: _unref(applyAnimations)('filter6')
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(CxList, {
            items: results.value,
            header: listHeader.value
          }, {
            default: _withCtx(({ item, selected }) => [
              _createVNode(CxListItem, {
                item: item,
                selected: selected,
                disabled: true
              }, {
                selection: _withCtx(() => [
                  _hoisted_9
                ]),
                "before-content": _withCtx(({}) => [
                  _createVNode(CxIcon, {
                    icon: "cx_points",
                    size: 15,
                    class: "cxu-color-faded"
                  })
                ]),
                _: 2
              }, 1032, ["item", "selected"]),
              _withDirectives(_createVNode(NCxSelect, {
                items: cellSizesToDisplay.value,
                selectedItemIds: [selectedCellSize.value],
                "onUpdate:selectedItemIds": _cache[0] || (_cache[0] = (value) => setSelectedCellSize(value[0])),
                activatorPlaceholder: translations.value.cellSizes,
                multiselect: false,
                label: translations.value.displaySettings,
                disabled: !results.value.length
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", null, _toDisplayString(translations.value.displaySettings), 1)
                  ])
                ]),
                _: 1
              }, 8, ["items", "selectedItemIds", "activatorPlaceholder", "label", "disabled"]), [
                [_vShow, _unref(isAnimationReady)]
              ])
            ]),
            placeholder: _withCtx(() => [
              _createVNode(CxLabel, {
                class: "cx-simple-list__placeholder results-placeholder",
                label: translations.value.noResult
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["items", "header"]), [
            [_vShow, _unref(isAnimationReady)]
          ])
        ]),
        _: 1
      }, 8, ["name"])
    ]),
    _createVNode(_Transition, {
      name: _unref(applyAnimations)('action')
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(CxFilterActionPanel, {
          onApplyClicked: display,
          applyTooltip: translations.value.display,
          applyText: translations.value.display,
          isDisabled: displayButtonDisabled.value,
          queryOngoing: displayLoading.value,
          isClearFiltersVisible: false
        }, {
          default: _withCtx(() => [
            _createVNode(CxMenuButton, {
              text: translations.value.export,
              items: exportExtensions.value,
              class: "cx-filter-action-panel__button--export",
              disabled: exportButtonDisabled.value,
              width: 220,
              menuPosition: "top",
              onClick: _cache[1] || (_cache[1] = (extension) => exportSurfaceLog(extension.value)),
              loading: exporting.value
            }, null, 8, ["text", "items", "disabled", "loading"])
          ]),
          _: 1
        }, 8, ["applyTooltip", "applyText", "isDisabled", "queryOngoing"]), [
          [_vShow, _unref(isAnimationReady)]
        ])
      ]),
      _: 1
    }, 8, ["name"])
  ]))
}
}

})